import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"circle"}/>
}
